"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const button_1 = __importDefault(require("components/cosmos/button/button"));
const modal_1 = require("components/cosmos/v2/modal");
const moduleList_1 = require("components/moduleList");
const translate_1 = require("components/translate");
const constants_1 = require("configs/routes/constants");
const useShellContext_1 = require("hooks/useShellContext");
const mobx_react_1 = require("mobx-react");
const aiContent_1 = require("modules/app/services/datahub/aiContent");
const ContentService_1 = __importDefault(require("modules/content/ContentService"));
const ModuleEditorParamsUtils_1 = __importDefault(require("modules/content/moduleEditor/ModuleEditorParamsUtils"));
const OnboardingService_1 = __importDefault(require("modules/content/onboarding/OnboardingService"));
const featureToggle_1 = require("modules/featureToggle");
const UiService_1 = __importDefault(require("modules/ui/UiService"));
const AIContentContext_1 = require("./AIContentContext");
const ChangeModuleItemsUtils_1 = __importDefault(require("./ChangeModuleItemsUtils"));
const CreateModuleItemsUtils_1 = __importDefault(require("./CreateModuleItemsUtils"));
const ContentList_module_scss_1 = __importDefault(require("./ContentList.module.scss"));
const mapStateToProps = (stores) => ({
    isContentListConceptEnabled: stores.FeatureToggleStore.featureToggles.get(featureToggle_1.FeatureToggles.ContentListConcept)
});
const ContentList = ({ onPreviousStep, onNextStep, t, isContentListConceptEnabled }) => {
    const [isAddingContent, setIsAddingContent] = (0, react_1.useState)(false);
    const { modules, setModules } = (0, AIContentContext_1.useAIContentContext)();
    const history = (0, react_router_1.useHistory)();
    const { isMembership } = (0, useShellContext_1.useShellContext)();
    const isAddingContentEnabled = modules.some((module) => module.isChecked || module.pages.some((page) => page.isChecked));
    const handleBack = () => {
        onPreviousStep();
        aiContent_1.DatahubAIContentService.sendDiscardStructure();
    };
    const handleModuleChange = (moduleId) => {
        setModules((prevState) => ChangeModuleItemsUtils_1.default.changeModule(moduleId, prevState));
    };
    const handleModulePageChange = (moduleId, pageId) => {
        setModules((prevState) => ChangeModuleItemsUtils_1.default.changeModulePage(moduleId, pageId, prevState));
    };
    const handleAddContent = async () => {
        setIsAddingContent(true);
        const isExtraModule = ModuleEditorParamsUtils_1.default.getExtraParam();
        const seasonId = null;
        try {
            await CreateModuleItemsUtils_1.default.create(modules, isExtraModule);
            UiService_1.default.setAlertSuccess('done');
            const totalSelectedModules = modules.filter((module) => module.isChecked).length;
            let totalSelectedPages = 0;
            modules.forEach((module) => {
                totalSelectedPages += module.pages.filter((page) => page.isChecked).length;
            });
            aiContent_1.DatahubAIContentService.sendAddStructure({
                totalSelectedModules,
                totalSelectedPages
            });
            await OnboardingService_1.default.updateStatusContentAndApprovedStatus();
        }
        catch (e) {
            UiService_1.default.handleError(e);
        }
        if (isContentListConceptEnabled && isMembership) {
            const searchParams = new URLSearchParams(window.location.search);
            if (ContentService_1.default.lastCreatedModule) {
                searchParams.set('moduleId', ContentService_1.default.lastCreatedModule);
            }
            searchParams.set('arrivedFrom', 'content');
            history.push(`${constants_1.ROUTES.CONTENT.LIST}?${searchParams.toString()}`);
        }
        else {
            await ContentService_1.default.fetchModulesList(seasonId, isExtraModule);
        }
        onNextStep();
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(modal_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)("h2", { className: "_text-4 _font-weight-bold _mb-0", children: t('ai_content_structure.step_03.title') }) }), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Body, { className: ContentList_module_scss_1.default.container, children: [(0, jsx_runtime_1.jsx)("p", { className: "_mt-0 _mb-5", children: t('ai_content_structure.step_03.description') }), (0, jsx_runtime_1.jsx)(moduleList_1.ModuleList, { modules: modules, onModuleChange: handleModuleChange, onModulePageChange: handleModulePageChange })] }), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Footer, { className: "_d-flex _justify-content-end", children: [(0, jsx_runtime_1.jsx)(button_1.default, { variation: "secondary", className: "_mr-3", onClick: handleBack, children: t('general.back') }), (0, jsx_runtime_1.jsx)(button_1.default, { variation: "primary", onClick: handleAddContent, loading: isAddingContent, disabled: !isAddingContentEnabled, children: t('ai_content_structure.step_03.add_content') })] })] }));
};
exports.default = (0, translate_1.translate)()((0, mobx_react_1.inject)(mapStateToProps)(ContentList));
